import { EDestinationType } from '@/core/interfaces';
import { Logger } from '@/shared/logger/logger';

import { MetaCookieLogic } from './bundles/meta/cookie_logic';
import { TiktokCookieLogic } from './bundles/tiktok/cookie_logic';

export function initializeDestinationCookies(
  destinationTypes: EDestinationType[],
  newCookies: Record<string, any>,
  iqpars: Record<string, string[]>,
  timestamp: number,
): { cookiesChanged: boolean; newCookies: Record<string, any> } {
  let cookiesChanged = false;
  destinationTypes.forEach(type => {
    switch (type) {
      case EDestinationType.Facebook: {
        const updatedCookies = MetaCookieLogic.updateCookies(
          newCookies,
          iqpars,
          timestamp,
        );
        if (JSON.stringify(updatedCookies) !== JSON.stringify(newCookies)) {
          cookiesChanged = true;
        }
        newCookies = updatedCookies;
        break;
      }
      case EDestinationType.GA4: {
        // TODO: pass measurementId and refactor
        // const updatedCookies = Ga4CookieLogic.updateCookies(
        //   newCookies,
        //   iqpars,
        //   Ga4CookieLogic.cookiesToUpdate,
        //   destinationSetting.measurementId,
        // );
        // if (JSON.stringify(updatedCookies) !== JSON.stringify(newCookies)) {
        //   cookiesChanged = true;
        // }
        // newCookies = updatedCookies;
        break;
      }
      case EDestinationType.TikTok: {
        const updatedCookies = TiktokCookieLogic.updateCookies(
          newCookies,
          iqpars,
        );
        if (JSON.stringify(updatedCookies) !== JSON.stringify(newCookies)) {
          cookiesChanged = true;
        }
        newCookies = updatedCookies;
        break;
      }
      default: {
        break;
      }
    }
  });
  return { cookiesChanged, newCookies };
}

export const DestinationCookieInitializer = {
  initializeDestinationCookies(
    existingCookies: Record<string, any>,
    iqpars: Record<string, string[]>,
    destinationTypes: EDestinationType[],
    timestamp: number,
  ): { cookiesChanged: boolean; newCookies: Record<string, any> } {
    let newCookies = { ...existingCookies };
    let cookiesChanged = false;
    ({ cookiesChanged, newCookies } = initializeDestinationCookies(
      destinationTypes,
      existingCookies,
      iqpars,
      timestamp,
    ));

    Logger.debug('Initialized destination cookies', {
      cookiesChanged,
      existingCookies,
      iqpars,
      newCookies,
    });

    return { cookiesChanged, newCookies };
  },
};
